export default __webpack_public_path__ + "static/media/NoAssignmentFound.217d73d2.svg";